/**
 * Converts a px value to rem based on 16px base font-size.
 * Used throughout the design system to enable proportional scaling
 * via html { font-size } overrides.
 *
 * @example
 * pxToRem(16)   // '1rem'
 * pxToRem(24)   // '1.5rem'
 * pxToRem(-150) // '-9.375rem'
 */
export function pxToRem(px: number): string {
  return `${px / 16}rem`;
}
